// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "$base-radius: 11px;\n$very-light-blue: #EEF6FF;\n$light-blue-active: #4a90e2;\n$light-pastel-blue: #96bfef;\n$dark-grey: #b2c4d7;\n$desc-grey: #5c5c5c;\n$dummy-bkgr-grey: #f9f9f9;\n$success-green: #0cd185;\n$error-red: #ff0000;\n$text-light-grey: #9b9b9b;\n$track-neutral-color: #dee1e3; \n$dark-red: #CE3923; \n$icon-inactive-color: #B4BBC3;\n$icon-active-blue-color: #4A90E2;\n$header-height: 60px;\n$entity-menu-width: 60px;", ""]);
// Exports
module.exports = exports;
